import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { JoinScreen } from "@/external/tasting/JoinScreen";

export const Route = createFileRoute("/sensory/join/$join_code")({
  component: PublicJoinPage,
});

function PublicJoinPage() {
  const { join_code } = Route.useParams();
  const navigate = useNavigate();
  return <JoinScreen joinCode={join_code} onJoined={(token) => navigate({ to: "/sensory/$token", params: { token } })} />;
}
